import { render } from "./InvoiceView.vue?vue&type=template&id=09faf84c&scoped=true&ts=true"
import script from "./InvoiceView.vue?vue&type=script&lang=ts"
export * from "./InvoiceView.vue?vue&type=script&lang=ts"

import "./InvoiceView.vue?vue&type=style&index=0&id=09faf84c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09faf84c"]])

export default __exports__